<template>
  <div>
    <template slot="header">
      <div class="row">
        <div class="col-6">
          <h3 class="mb-0">{{ $t("PRODUCTS.PRODUCTS_LIST") }}</h3>
        </div>
        <div class="col-6 text-right">
          <base-button
            type="primary"
            icon
            size="sm"
            @click="addProduct()"
            v-if="$currentUserCan($permissions.PERM_CREATE_PRODUCTS)"
          >
            <span class="btn-inner--icon">
              <i class="fas fa-plus"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("PRODUCTS.ADD_PRODUCT") }}
            </span>
          </base-button>
        </div>
      </div>
    </template>
    <div>
      <div class="col-12 row">
        <div class="col-6 col-md-3">
          <base-input>
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              :placeholder="$t('COMMON.PER_PAGE')"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div
          class="col-6 col-md-3"
          v-if="
            !filterOrganization &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
          "
        >
          <base-input>
            <organization-selector
              @organizationChanged="
                (organizationId) => (selectedOrganization = organizationId)
              "
            />
          </base-input>
        </div>
        <div
          class="col-6 col-md-3"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOCATIONS)"
        >
          <base-input :placeholder="`${$t('COMMON.LOCATIONS')}`">
            <locations-selector
              @locationsChanged="(locations) => (selectedLocations = locations)"
            />
          </base-input>
        </div>

        <div class="col-6 row col-md-3">
          <div class="col-7">
            <base-input>
              <el-select
                :clearable="true"
                class="select-primary pagination-select"
                v-model="product_status"
                :placeholder="$t('COMMON.STATUS')"
              >
                <el-option
                  class="select-primary"
                  v-for="(item, key) in PRODUCT_STATUS"
                  :key="key"
                  :label="$t(`PRODUCTS.STATUS_${item}`)"
                  :value="item"
                >
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-5">
            <base-checkbox v-model="latestProduct" class="mb-3">
              <span class="form-control-label">
                {{ $t("COMMON.NEW") }}
              </span>
            </base-checkbox>
          </div>
        </div>

        <div
          class="col-6 col-md-3"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOCATIONS)"
        >
          <base-input :placeholder="`${$t('COMMON.LOCATIONS')}`">
            <supplier-selector
              :multiple="false"
              :allowNone="true"
              :showAll="false"
              @supplierChanged="(supplier) => (selectedSupplier = supplier)"
            />
          </base-input>
        </div>

        <!--
  <div
          class="col-6 col-md-3"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_CATEGORIES)"
        >
          <base-input>
            <categories-selector
              :allowNone="false"
              :showAll="false"
              :placeholder="$t('CATEGORIES.HIERARCHICAL_CATEGORY')"
              :isOnlyModels="false"
              @categoryChanged="
                (categoriesIds) => {
                  selectedHierarchicalCategoriesIds = categoriesIds;
                }
              "
            />
          </base-input>
        </div>
-->

        <div
          class="col-6 col-md-3"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_CATEGORIES)"
        >
          <base-input>
            <category-group-selector
              :allowNone="false"
              :showAll="false"
              :isOnlyModels="false"
              :placeholder="$t('COMMON.CATEGORIES')"
              @categoryChanged="
                (categoriesIds) => {
                  selectedInCategoryId = categoriesIds;
                }
              "
            />
          </base-input>
        </div>

        <div class="col-6 col-md-3">
          <base-input
            v-model="query"
            type="search"
            prepend-icon="fas fa-search"
            :placeholder="$t('COMMON.SEARCH')"
            clearable
          />
        </div>
      </div>

      <el-table
        class="table-responsive align-items-center table-flush"
        header-row-class-name="thead-light"
        :data="products"
        @sort-change="sortChange"
      >
        <div slot="empty" v-if="loading">
          <img src="/img/loading.gif" style="height: 100px; width: 100px" />
        </div>
        <el-table-column label="" min-width="50px">
          <template v-slot="{ row }">
            <img
              v-if="row.picture"
              :src="row.picture"
              class="avatar rounded-circle mr-3"
            />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('COMMON.CODE')"
          prop="code"
          sortable="custom"
        />
        <el-table-column
          :label="$t('PRODUCTS.SKU')"
          prop="sku"
          sortable="custom"
        />
        <el-table-column
          :label="$t('COMMON.NAME')"
          prop="name"
          sortable="custom"
        />
        <el-table-column
          :label="$t('COMMON.SELLING_PRICE')"
          prop="selling_price"
          sortable="custom"
        >
          <template v-slot="{ row }">
            <span v-if="row.can_be_sold">
              {{ $formatCurrency(row.selling_price) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('COMMON.BUYING_PRICE')"
          prop="selling_price"
          sortable="custom"
        >
          <template v-slot="{ row }">
            <span v-if="row.can_be_purchased">
              {{ $formatCurrency(row.buying_price) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('COMMON.LOCATIONS')"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOCATIONS)"
        >
          <template v-slot="{ row }">
            <locations :locations="row.allowedLocations" />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('COMMON.ORGANIZATION')"
          v-if="
            !filterOrganization &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
          "
        >
          <template v-slot="{ row }">
            <organization :organization="row.organization" />
          </template>
        </el-table-column>

        <el-table-column :label="$t('COMMON.STATUS')">
          <template v-slot="{ row }">
            <div class="d-flex">
              <product-status-badge :product="row" />
              <product-novelty-badge :product="row" />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('COMMON.CREATED_AT')"
          prop="created_at"
          sortable="custom"
        >
          <template v-slot="{ row }">
            {{ $formatDate(row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column align="center">
          <div slot-scope="{ row }" class="table-actions">
            <el-tooltip
              :content="$t('COMMON.VIEW')"
              placement="top"
              v-if="$currentUserCan($permissions.PERM_VIEW_PRODUCTS)"
            >
              <a
                type="text"
                @click="viewProduct(row)"
                class="table-action"
                data-toggle="tooltip"
                style="cursor: pointer"
              >
                <i class="fas fa-eye"></i>
              </a>
            </el-tooltip>

            <el-tooltip
              :content="$t('COMMON.EDIT')"
              placement="top"
              v-if="$currentUserCan($permissions.PERM_EDIT_PRODUCTS)"
            >
              <a
                type="text"
                @click="editProduct(row)"
                class="table-action"
                data-toggle="tooltip"
                style="cursor: pointer"
              >
                <i class="fas fa-edit"></i>
              </a>
            </el-tooltip>

            <el-tooltip
              content="Delete"
              placement="top"
              v-if="$currentUserCan($permissions.PERM_DELETE_PRODUCTS)"
            >
              <a
                type="text"
                @click="deleteProduct(row.id)"
                class="table-action table-action-delete"
                data-toggle="tooltip"
                style="cursor: pointer"
              >
                <i class="fas fa-trash"></i>
              </a>
            </el-tooltip>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="mt-5 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap table-footer"
    >
      <div class="">
        <p class="card-category">
          {{
            $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
              from: total ? from + 1 : 0,
              to: to,
              of: total,
            })
          }}

          <span v-if="selectedRows.length">
            &nbsp; &nbsp;
            {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
          </span>
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { BasePagination } from "@/components";
import { PRODUCT_STATUS, STATUS_ACTIVE } from "@/constants/products";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import LocationsSelector from "@/components/LocationsSelector.vue";
import SupplierSelector from "@/components/SupplierSelector.vue";
import CategoryGroupSelector from "@/components/CategoryGroupSelector.vue";
import ProductStatusBadge from "../../../../../components/ProductStatusBadge";
import ProductNoveltyBadge from "../../../../../components/ProductNoveltyBadge";

export default {
  name: "product-list-table",

  components: {
    BasePagination,
    SupplierSelector,
    OrganizationSelector,
    LocationsSelector,
    CategoryGroupSelector,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    ProductStatusBadge,
    ProductNoveltyBadge,
  },

  mixins: [requestErrorMixin],

  props: {
    filterOrganization: {
      type: String,
      default: null,
      description: "organization id",
    },
  },

  data() {
    return {
      query: null,
      latestProduct: false,
      product_status: STATUS_ACTIVE,
      selectedRows: [],
      PRODUCT_STATUS,
      sort: "-created_at",
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      products: [],
      loading: true,
      selectedOrganization: null,
      selectedLocations: null,
      selectedHierarchicalCategoriesIds: [],
      selectedInCategoryId: [],
      selectedSupplier: null,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    product_status: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    filterOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedLocations: {
      handler: "getListDebounced",
      immediate: true,
    },
    latestProduct: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedSupplier: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedHierarchicalCategoriesIds: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedInCategoryId: {
      handler: "getListDebounced",
      immediate: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: this.query } : {}),
            ...(this.product_status ? { status: this.product_status } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
          include: "organization,allowedLocations,categories",
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.latestProduct) {
          params = {
            ...params,
            filter: { ...params.filter, latestProduct: this.latestProduct },
          };
        }
        if (this.selectedSupplier) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              supplierProduct: this.selectedSupplier,
            },
          };
        }
        if (this.selectedOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.selectedOrganization,
            },
          };
        }
        if (this.selectedLocations) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              allowedLocations: this.selectedLocations.map((loc) => loc.id),
            },
          };
        }

        if (this.selectedHierarchicalCategoriesIds) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              hierarchical_category_association:
                this.selectedHierarchicalCategoriesIds.map(
                  (category) => category.id
                ),
            },
          };
        }

        if (this.selectedInCategoryId) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              in_category: this.selectedInCategoryId,
            },
          };
        }

        await this.$store.dispatch("products/list", params);
        this.products = this.$store.getters["products/list"];
        this.total = this.$store.getters["products/listTotal"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async deleteProduct(id) {
      const confirmation = await swal.fire({
        title: this.$t("PRODUCTS.DELETE_THIS_PRODUCT"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("products/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: this.$t("PRODUCTS.PRODUCT_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    viewProduct(product) {
      this.$router.push({
        name: "View Product",
        params: { id: product.id },
      });
    },

    async editProduct(row) {
      this.$router.push({
        name: "Edit Product",
        params: { id: row.id },
      });
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
